import { Title } from '@angular/platform-browser';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';
import { FunnelItem } from './../../../../../../models/funnels';
import { SharedFunnelService } from './../../../../funnel/shared-funnel.service';

import { SharedSfxService } from './../../../../../../shared/services/shared-sfx.service';
import { PortalViewPageStatusEnum } from './../../shared-portal-view.service';
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilteringTypeModel, SortingTypeModel } from 'src/app/models/portal';

import { PromptingService } from 'src/app/shared/services';
import { SharedPortalViewService } from '../../shared-portal-view.service';
import { PageItem } from '../../../../../../models/portal';
import { ApiService } from '../../../../../../shared/services/lsg.api.service';
import { lastValueFrom, map, Observable } from 'rxjs';
import { DivStateAnimation } from '../../../../../../shared/animations/animations';
import { Store } from '@ngrx/store';
import { ProductItem } from 'src/app/components/user-dashboard/product/models/product';
import {
  isProductsLoaded,
  selectProducts,
} from 'src/app/shared/store/_features/products/products.selector';
import { SharedProductService } from 'src/app/components/user-dashboard/product/shared-product.service';

@Component({
  selector: 'app-portal-funnels',
  templateUrl: './portal-funnels.component.html',
  styleUrls: ['./portal-funnels.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    DivStateAnimation,
  ],
})
export class PortalFunnelsComponent implements OnInit {
  userWebsitePages: FunnelItem[];
  WebsitePagesScreenshots: string[];
  WebsitePagesScreenshotsLoad: boolean[];

  // UI Tools
  bonk: HTMLAudioElement = new Audio('assets/bonk.mp3');
  crumbling: HTMLAudioElement = new Audio('assets/paper-crumbling.mp3');
  // Pagination
  currentPage = 1;
  startIndex = 0;
  numberInPage = 6;
  endIndex = 6;

  // Sort And Filtering Features
  searchWord: string = '';
  sortObject: SortingTypeModel = {
    displayName: 'Recently Updated',
    column: 'modifiedParse',
    order: 'dsc',
  };
  sortTypes: SortingTypeModel[] = [
    //{ displayName: 'Newest', column: 'createdAt', order: 'dsc' },
    //{ displayName: 'Oldest', column: 'createdAt', order: 'asc' },
    { displayName: 'Recently Updated', column: 'modifiedParse', order: 'dsc' },
    { displayName: 'A-Z Title', column: 'title', order: 'asc' },
    { displayName: 'Z-A Title', column: 'title', order: 'dsc' },
  ];

  coursesLoaded$: Observable<boolean>;
  courses$: Observable<ProductItem[]>;

  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    public api: ApiService,
    private route: Router,
    public sharedFunnelService: SharedFunnelService,
    public sharedSfxService: SharedSfxService,
    public sharedOwnerDashboardService: SharedOwnerDashboardService,
    private title: Title,
    private prompting: PromptingService,
    private store: Store,
    public sharedProductService: SharedProductService,
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.funnels,
    );
    this.coursesLoaded$ = this.store.select(isProductsLoaded);
    this.courses$ = this.store
      .select(selectProducts)
      .pipe(
        map((products) => products.filter((p) => p.type.name === 'course')),
      );
  }

  async ngOnInit() {
    await this.sharedProductService.getProducts();

    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
        ' > ' +
        'Sales Funnels',
    );
  }

  manageCourseFunnel(courseId: number) {
    this.route.navigate([
      '/dashboard/product',
      courseId,
      'course',
      'funnel-and-go-live',
    ]);
  }

  // Pages Function
  async DeletePage(page: PageItem) {
    const id = this.sharedPortalViewService.currentWebsite.id;
    const pageArrayID =
      this.sharedPortalViewService.currentWebsite.pages.findIndex(
        (a) => a.id === page.id,
      );

    this.prompting.confirm(
      {
        allowOutsideClick: false,
        input: 'checkbox',
        inputPlaceholder:
          'I confirm that I want to Delete ' + page.title + ' Page.',
        title: 'You’re about to Delete a Page',
        html:
          "<br><span style='font-size:1.2em'>Are you sure you want to Delete</span><br> " +
          page.title +
          ` <br>
        <span class='badge badge-light-danger text-danger badge-lg mt-3' style='text-transform:uppercase'>
        <i class="ler-duotone ler-trash text-danger fs-2 me-2">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
        </i> this step cannot be undone
        </span>`,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.sharedSfxService.playBonk();
          return lastValueFrom(this.api.deletePage(+id, page.id)).then(
            async (resultFromReq: any) => {
              if (resultFromReq && !!resultFromReq.success) {
                this.prompting.close();
                this.sharedSfxService.playCrumble();
                this.sharedPortalViewService.currentWebsite.pages.splice(
                  pageArrayID,
                  1,
                );
                this.refreshPagesArray();
              }
              return undefined;
            },
          );
        },
        inputValidator: (result) => {
          return !result && 'You need to agree';
        },
        didOpen: () => {
          const confirmButton =
            this.prompting.getConfirmButton() as HTMLButtonElement;
          const checkbox = this.prompting.getInput() as HTMLInputElement;

          if (confirmButton && checkbox) {
            confirmButton.disabled = !checkbox.checked;
            checkbox.addEventListener('change', () => {
              confirmButton.disabled = !checkbox.checked;
            });
          }
        },
        isDanger: true,
      },
      'lg',
    );
  }
  refreshPagesArray() {
    this.sharedPortalViewService.currentWebsite.pages = [].concat(
      this.sharedPortalViewService.currentWebsite.pages,
    );
  }

  // Page Edit Functions

  // Sort And Filtering Features
  sortTypeChange(sortObject: SortingTypeModel) {
    this.sortObject = sortObject;
  }
  resetPagination() {
    this.startIndex = 0;
    this.endIndex = this.numberInPage;
    this.currentPage = 1;
  }

  goToTutorials() {
    this.route.navigate(['/dashboard/tutorials']);
  }

  onSearchWordChange(value: any) {
    this.searchWord = value;
  }

  consoleHandler(data: any) {}

  // Pagination
  getArrayLenght(length) {
    return new Array(this.getPagesNumber(length));
  }

  getPagesNumber(length) {
    return Math.ceil(length / this.numberInPage);
  }

  getIndex(pageIndex) {
    if (pageIndex > 0) {
      this.currentPage = pageIndex;
      this.startIndex = (pageIndex - 1) * this.numberInPage;
      this.endIndex = this.startIndex + this.numberInPage;
    }
  }
}
